import { subDays, subMonths } from "date-fns"

// Every period reads the durable store (acc.UserSignInEvents, kept current by
// v2-auth-monitor) via a paged SQL query — periodFrom is the only window knob.
// "Last 100" maps to no `from` (newest-first, paged).
export type Period = "last100" | "24h" | "7d" | "30d" | "90d" | "6mo" | "12mo"

export const PERIOD_OPTIONS: { value: Period; label: string }[] = [
  { value: "last100", label: "Last 100" },
  { value: "24h", label: "24 hours" },
  { value: "7d", label: "7 days" },
  { value: "30d", label: "30 days" },
  { value: "90d", label: "90 days" },
  { value: "6mo", label: "6 months" },
  { value: "12mo", label: "12 months" },
]

// Window start for the period, or undefined for "last100" (recency-capped, no
// time bound).
export function periodFrom(period: Period): string | undefined {
  switch (period) {
    case "24h":
      return subDays(new Date(), 1).toISOString()
    case "7d":
      return subDays(new Date(), 7).toISOString()
    case "30d":
      return subDays(new Date(), 30).toISOString()
    case "90d":
      return subDays(new Date(), 90).toISOString()
    case "6mo":
      return subMonths(new Date(), 6).toISOString()
    case "12mo":
      return subMonths(new Date(), 12).toISOString()
    default:
      return undefined
  }
}
